import * as React from 'react';
import { Helper } from './Helper';

const errorClass = 'alert-danger';
const successClass = 'alert-success';
const infoClass = 'alert-info';
const errorIcon = 'win-icon-ErrorBadge win-color-fg-red';
const successIcon = 'win-icon-Completed win-color-fg-green';
const infoIcon = 'win-icon-Info';

type AlertBannerProps = {
  alertType: string;
  title?: string;
  body: string;
  onClose: () => void;
};
export const AlertType = {
  error: 'error',
  success: 'success',
  info: 'info',
};
export default class AlertBanner extends React.Component<AlertBannerProps> {
  private getAlertClass = () => {
    if (this.props.alertType === AlertType.error) return errorClass;
    if (this.props.alertType === AlertType.success) return successClass;
    if (this.props.alertType === AlertType.info) return infoClass;
    return '';
  };
  private getIconClass = () => {
    if (this.props.alertType === AlertType.error) return errorIcon;
    if (this.props.alertType === AlertType.success) return successIcon;
    if (this.props.alertType === AlertType.info) return infoIcon;
    return '';
  };
  public render() {
    const alertClass = this.getAlertClass();
    const iconClass = this.getIconClass();
    if (Helper.isEmptyOrSpaces(alertClass)) {
      return <div className="col-xs-24 spacer-lg-top" />;
    }
    return (
      <div className="alert-band">
        <div className={'alert with-icon alert-dismissible fade in ' + alertClass} role="alert">
          <button type="button" className="close" onClick={this.props.onClose} data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true">
              <i className="win-icon win-icon-Cancel"></i>
            </span>
          </button>
          <span className="alert-icon">
            <i className={'win-icon ' + iconClass}></i>
          </span>
          {!Helper.isEmptyOrSpaces(this.props.title ?? '') && <div className="alert-title">{this.props.title}</div>}
          <div className="row">
            <div className="col-xs-24" dangerouslySetInnerHTML={{ __html: this.props.body }}></div>
          </div>
        </div>
      </div>
    );
  }
}
